import SignalTable from 'components/global/SignalTable/SignalTable';
import SimpleCard from 'components/global/SimpleCard';
import FounderInviteRows from 'components/views/FounderTeam/_components/FounderInviteRow';
import { fetchAndSetFounderInvites } from 'components/views/FounderTeam/_helpers/founderTeam.resolvers';
import { $list, $view } from 'signals/global.signals';
import useEffectAsync from 'utils/useEffectAsync';

const FounderInvites = () => {
  useEffectAsync(fetchAndSetFounderInvites);
  return (
    <SimpleCard>
      <SignalTable
        headers={[{
          value: 'Email',
          key: 'email',
        },
        {
          value: 'Actions',
          key: 'Actions',
        }]}
        rows={FounderInviteRows({ data: $list.value.data || [] })}
        isLoading={$view.value.isTableLoading}
      />
    </SimpleCard>
  );
};

export default FounderInvites;
